import { render, staticRenderFns } from "./CurrencyInput.vue?vue&type=template&id=2b1354fc"
import script from "./CurrencyInput.vue?vue&type=script&lang=ts"
export * from "./CurrencyInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports